import set from "@rill/set";
import moment from "moment";
import BlockReview from "./BlockReview";
import FilterBlockReviewModal from "../../../../parts/modals/filter-block-review";
import JWPlayerVideoModal from "../../../../parts/modals/jwplayer-video";
import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";

const BlockReviewController = (app) => {
  app.get(
    "/block-review",
    set("heading", "Block Review"),
    async ({ req, res, locals, load }) => {
      const { query } = req;
      const { from, to } = query;
      const modal = query.modal || {};

      const athleteId = locals.athlete
        ? locals.athlete._id
        : locals.activeUser._id;

      await load("weeksExercises", {
        from: from ? from : moment().subtract(4, "weeks").format("YYYY-MM-DD"),
        to: to ? to : moment().format("YYYY-MM-DD"),
        proxyAthlete: athleteId,
      });

      locals.modal = {
        "filter-block-review-modal": (
          <FilterBlockReviewModal
            filtersModal={query.filtersModal}
            exerciseFilters={query.exerciseFilters}
          />
        ),
        "exercise-set-video": (
          <JWPlayerVideoModal
            mediaId={query.mediaId}
            originalId={query.originalId}
            athleteId={query.uploaderId || query.athlete}
          />
        ),
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      res.body = <BlockReview locals={locals} />;
    }
  );
};

export default BlockReviewController;
